<template>
  <div class="col-sm-6 col-md-4 _col-lg-3">
    <div class="collage-photo-item" :class="{ 'collage-photo-item--loading': !imageLoaded }">

      <div v-if="!imageLoaded" class="spinner-container">
        <b-spinner large type="grow" class="loading-spinner"></b-spinner>
      </div>

      <div class="collage-photo-item__image-container" :class="{'cursor-default': !enableZoom }"
           @click="handlePhotoClicked">
        <img v-lazy="photo.image_url"  @load="imageLoaded = true"
                      class="collage-photo-item__image" :class="{'is-portrait': isPortrait}"/>
      </div>

      <div class="collage-photo-item__caption" :style="{visibility: imageLoaded ? 'visible' : 'hidden'}">
        <div v-if="hasPhotoOriginal" class="collage-photo-item__caption__label">
          <span class="icon-hd mr-2" v-b-tooltip.hover :title="$t('collage_photo_item.hd_size')">HD</span>
          <span class="text-secondary">{{ photo.original_width }}x{{ photo.original_height }} pixel</span>
        </div>

        <div class="d-flex ml-auto">
          <button v-show="enableZoom" class="btn btn-light mr-2 p-2" @click="$emit('zoom-clicked', photo)"
                  v-b-tooltip.hover :title="$t('collage_photo_item.zoom')">
            <img src="@/assets/icon-zoom.svg" height="20">
          </button>

          <div v-if="initiallySelected" class="btn btn-sm btn__photo btn__photo--remove" style="cursor: auto"
               v-b-tooltip.hover :title="$t('collage_photo_item.selected_tooltip')">
            {{ $t('collage_photo_item.selected') }} <img src="@/assets/icon-check.svg">
          </div>

          <button v-else class="btn btn-sm btn__photo ml-auto mr-auto"
                  :class="{'btn__photo--add': !selected, 'btn__photo--remove': selected}"
                  @click="toggleSelection()">
            <!--                    <b-spinner small v-show="isLoading"></b-spinner>-->
            <span v-show="selected">{{ $t('collage_photo_item.unselect_photo') }}</span>
            <span v-show="! selected">{{ $t('collage_photo_item.select_photo') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  props: {
    photo: Object,

    selected: {
      type: Boolean,
      default: false
    },

    initiallySelected: {
      type: Boolean,
      default: false
    },

    isUnlocked: {
      type: Boolean,
      default: false
    },

    hasPhotoOriginal: {
      type: Boolean,
      default: false
    },

    enableZoom: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      imageLoaded: false,
    }
  },

  computed: {
    isPortrait() {
      return this.photo.original_height > this.photo.original_width
    },

    isNotSelected() {
      return (!this.selected) && (!this.initiallySelected)
    },

    // isPhotoInCart() {
    //     return !!this.$store.getters['cart/isDigitalPhotoInCart'](this.picacode, this.photo.id)
    // },
  },

  methods: {
    toggleSelection() {
      let eventName = ''
      if (this.selected) {
        eventName = 'photo-unselected'
      }
      if (this.isNotSelected) {
        eventName = 'photo-selected'
      }

      this.$emit(eventName, this.photo.id)
      // this.selected ? this.removeFromCart() : this.addToCart()
    },

    handlePhotoClicked() {
      if (this.enableZoom) {
        this.$emit('zoom-clicked', this.photo.id)
      }
    }
  }
}
</script>
